import { createContext } from "react";

export const FinancialDocContext = createContext({
  financialDoc: {},
  onChange: () => {},
});
